import type { ReactNode } from 'react';
import { Route } from 'react-router-dom';

import { OnboardingCompletionGuard } from '@/app/router/OnboardingCompletionGuard';
import { ProtectedRoute } from '@/app/router/ProtectedRoute';

import { SimpleWorkflowEditorScreen } from './pages/SimpleWorkflowEditorScreen';
import { WorkflowEditorScreen } from './pages/WorkflowEditorScreen';
import { WorkflowsListScreen } from './pages/WorkflowsListScreen';

const guarded = (element: ReactNode) => (
  <ProtectedRoute>
    <OnboardingCompletionGuard>{element}</OnboardingCompletionGuard>
  </ProtectedRoute>
);

export const workflowsRoutes = (
  <>
    <Route path="/workflows" element={guarded(<WorkflowsListScreen />)} />
    {/* /workflows/new opens the list screen with the create modal pre-opened.
        The modal reads URL state via useMatch so the URL reflects app state. */}
    <Route path="/workflows/new" element={guarded(<WorkflowsListScreen />)} />
    <Route path="/workflows/:workflowId/editor" element={guarded(<WorkflowEditorScreen />)} />
    <Route path="/workflows/:workflowId/simple" element={guarded(<SimpleWorkflowEditorScreen />)} />
  </>
);
